import { TableBodyLine } from "@touche-lts/panel-ui/dist"

export default function TableBody({ elements, getBodyLineCells }) {
    return (
        <>
            {elements?.map((item, idx) => {
                return (
                    <TableBodyLine
                        id={idx === 0 ? "#top-row" : ""}
                        colorPreset='dark'
                        key={item?.product?.id}
                        cells={getBodyLineCells(item as any)}
                    />
                )
            })}
        </>
    )
}